import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {darkGray} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  dateText: {
    color: darkGray,
    fontSize: 14,
    marginBottom: 3,
  },
  infoColumn: {
    flex: 1,
  },
  titleText: {
    marginBottom: 4,
  },
  avatarColumn: {
    flex: 0,
  },
  optaviaTextContainer: {
    flexDirection: 'row',
    marginTop: indent * 0.3,
  },
  idContainer: {
    flexDirection: 'row',
  },
  copyIcon: {
    fontSize: 20,
    marginLeft: 4,
  },
});
